import {
  createAsyncThunk,
  createSlice,
} from "@reduxjs/toolkit";
import OrderService from "@/services/api/order";
import { handleResponse } from "@/services/axios";

interface OrdersState {
  orders: any[];
  history: any[];
  leadType: any[];
  orderDetail: any[];
  isFetching: boolean;
  error: string | null;
  orderSettings: any | null,
  loading: {
    OrderSetting: boolean;
    Orders: boolean;
  };
}

const initialState: OrdersState = {
  orders: [],
  history: [],
  leadType: [],
  orderDetail: [],
  isFetching: false,
  error: null,
  orderSettings: null,
  loading: {
    OrderSetting: false,
    Orders: false,
  }
};


export const getMyOrders = createAsyncThunk(
  "orders/getMyOrders",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await OrderService.Orders(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.Message || "Failed to fetch orders"
      );
    }
  }
);
export const getOrderHistoryLog = createAsyncThunk(
  "orders/getOrderHistoryLog",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await OrderService.History(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.Message || "Failed to fetch order history log"
      );
    }
  }

);
export const leadsByNextLeadType = createAsyncThunk(
  "orders/LeadsByNextLeadType",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await OrderService.LeadsByNextLeadType(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.Message || "Failed to fetch LeadType"
      );
    }
  }
);
export const OrderDetail = createAsyncThunk(
  "orders/OrderDetail",
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await OrderService.OrderDetail(params);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.Message || "Failed to fetch LeadType"
      );
    }
  }
);

// ORDER SETTINGS
export const setOrderSettings = createAsyncThunk(
  "orderSettings/setOrderSettings",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await OrderService.setOrderSettings(data);
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response.data.message || "Failed"
      );
    }
  },
)

export const getOrderSettings = createAsyncThunk(
  "orderSettings/getOrderSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await OrderService.getOrderSettings();
      return handleResponse(response, rejectWithValue);
    } catch (err: any) {
      return rejectWithValue(
        err?.response.data.message || "Failed"
      );
    }
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getMyOrders.pending, (state) => {
      state.loading.Orders = true;
      state.error = null;
    })
    builder.addCase(getMyOrders.fulfilled, (state, action) => {
      state.loading.Orders = false;
      state.orders = action.payload || [];
      state.error = null;
    })
    builder.addCase(getMyOrders.rejected, (state, action) => {
      state.loading.Orders = false;
      state.error = action.payload as string;
    })

    builder.addCase(getOrderHistoryLog.fulfilled, (state, action) => {
      state.history = action.payload || [];
    })
    builder.addCase(leadsByNextLeadType.fulfilled, (state, action) => {
      state.leadType = action.payload?.Leads || [];
    })
    builder.addCase(OrderDetail.fulfilled, (state, action) => {
      state.orderDetail = action.payload || [];
    })
    builder.addCase(getOrderSettings.pending, (state) => {
      state.error = null;
      state.orderSettings = null;
    })
    builder.addCase(getOrderSettings.fulfilled, (state, action) => {
      state.error = null;
      state.orderSettings = action.payload || null;
    })
    builder.addCase(getOrderSettings.rejected, (state, action) => {
      state.error = action.payload as string;
      state.orderSettings = null;
    })
    builder.addCase(setOrderSettings.pending, (state) => {
      state.loading.OrderSetting = true;
      state.error = null;
    })
    builder.addCase(setOrderSettings.fulfilled, (state, action) => {
      state.loading.OrderSetting = false;
      state.error = null;
    })
    builder.addCase(setOrderSettings.rejected, (state, action) => {
      state.loading.OrderSetting = false;
      state.error = action.payload as string;
    });

  },
});

export default ordersSlice.reducer;
